//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'
import $ from 'jquery'
import DateRangePicker from 'components/DateRangePicker'

const Pagination = require('../plugins/vue-bootstrap-paginator').default

export default {
  components: {
    ContentHeader,
    Pagination,
    DateRangePicker
  },
  data () {
    return {
      searchName: '',
      searchDataType: '',
      searchStatus: '',
      newOne: {date_scope: {}, trigger_term: {}},
      newDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      editDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      globalInfo: {},
      gameRoomList: [],
      triggerList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0,
      trigger: {date_scope: {}, trigger_term: {}}
    }
  },
  created () {
  },
  mounted () {
    // 获取娃娃机全局属性
    let $this = this
    Vue.http.get(this.serviceUrl('api/wawaji/global/info'), {params: {search_type: 'all'}}).then((resp) => {
      $this.globalInfo = resp.data.globalInfo;
    })
    // 获取所有房间信息
    Vue.http.get(this.serviceUrl('api/game/room/info'), {params: {search_type: 'all'}}).then((resp) => {
      $this.gameRoomList = resp.data.gameRoomList;
    })
    // 搜索
    $this.getTriggerList();
  },
  computed: {
  },
  methods: {
    // 获取触发器列表
    getTriggerList: function (page = 1) {
      let $this = this
      var params = {
        page: page,
        name: this.searchName,
        data_type: this.searchDataType,
        status: this.searchStatus
      }
      Vue.http.get(this.serviceUrl('api/get/trigger/list'), {params: params}).then((resp) => {
        let data = resp.data
        $this.triggerList = data.triggerList.data;
        $this.totalItems = data.triggerList.total;
        $this.currentPage = data.triggerList.current_page;
        $this.perPage = data.triggerList.per_page;
        $this.lastPage = data.triggerList.last_page;
      })
    },
    // 分页跳转
    pageChanged: function (page = 1) {
      this.getTriggerList(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      let appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getTriggerList(appointPage);
    },
    // 获取全局信息
    getGlobalData: function () {
      this.trigger = this.globalInfo;
    },
    // 修改状态
    changeStatus: function (row, type) {
      var params = {};
      params.trigger_id = row.trigger_id;
      params.type = type;
      let $this = this
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/change/trigger/status'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('操作成功', 1);
          row.status = type;
          $this.pageChanged();
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    },
    // 点击数据类型赋值
    showByDataType: function (row) {
      this.trigger = row;
    },
    // 编辑触发器赋值
    editTrigger: function (row) {
      this.trigger = row;
      if (row.data_type === '1') {
        this.trigger.trigger_term = {};
      } else if (row.data_type === '2') {
        this.trigger.date_scope = {};
      }
      if (row.data_type === '1' && row.date_scope) {
        this.editDate = {startDate: row.date_scope.start_time, endDate: row.date_scope.end_time, startDateText: row.date_scope.start_time, endDateText: row.date_scope.end_time};
      } else {
        this.editDate = {startDate: '', endDate: '', startDateText: '', endDateText: ''};
      }
    },
    // 保存触发器
    saveTrigger: function (focus, saveType) {
      var numIntegerRe = /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/;
      var rateRe = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$|^0.00$|^100.00$/;
      let $this = this
      if (!$.trim(focus.name)) {
        $this.alert('名称不能为空', 2);
        return false;
      }
      if (!focus.data_type) {
        $this.alert('请选择数据类型', 2);
        return false;
      }
      if (!focus.prob_type) {
        $this.alert('请选择概率调整类型', 2);
        return false;
      }
      if (!rateRe.test(focus.change_rate)) {
        $this.alert('调整概率数值不合法', 2);
        return false;
      }
      var params = {
        name: $.trim(focus.name),
        data_type: focus.data_type,
        prob_type: focus.prob_type,
        change_rate: $.trim(focus.change_rate),
        save_type: saveType
      };
      if (focus.data_type === '1') {
        if (!(focus.date_scope && focus.date_scope.repeat_type)) {
          $this.alert('请选择重复类型', 2);
          return false;
        }
        if (focus.game_room_id === '') {
          $this.alert('请绑定房间', 2);
          return false;
        }
        params['game_room_id'] = focus.game_room_id;
        params['repeat_type'] = focus.date_scope.repeat_type;
      } else if (focus.data_type === '2') {
        // 奖品数量
        if (!focus.trigger_term.opt && focus.trigger_term.opt !== '0') {
          $this.alert('请选择运算符号', 2);
          return false;
        }
        if (!numIntegerRe.test(focus.trigger_term.data_value)) {
          $this.alert('奖品数量请填写整数', 2);
          return false;
        }
        params['opt'] = focus.trigger_term.opt;
        params['data_value'] = focus.trigger_term.data_value;
      }
      if (saveType === 'add') {
        if (focus.data_type === '1') {
          // 时间段
          if (!this.newDate.startDateText || !this.newDate.endDateText) {
            $this.alert('请填写有效时间', 2);
            return false;
          }
          params['start_at'] = this.newDate.startDateText;
          params['end_at'] = this.newDate.endDateText;
        }
      } else if (saveType === 'edit') {
        params['trigger_id'] = focus.trigger_id;
        if (focus.data_type === '1') {
          if (!this.editDate.startDateText || !this.editDate.endDateText) {
            $this.alert('请选择有效时间', 2);
            return false;
          }
          params['start_at'] = this.editDate.startDateText;
          params['end_at'] = this.editDate.endDateText;
        }
      }
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/save/trigger/info'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          if (saveType === 'add') {
            $this.alert('新增成功', 1);
            $('.js-add-trigger-modal').modal('hide');
            $this.getTriggerList();
          } else {
            $this.alert('保存成功', 1);
            $('.js-edit-trigger-modal').modal('hide');
            $this.pageChanged();
          }
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    },
    // 保存全局信息
    saveGlobalInfo: function (row) {
      var numRe = /^\d+$/;
      var rateRe = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$|^0.00$|^100.00$/;
      let $this = this
      if (!numRe.test(row.base_prize_amount)) {
        $this.alert('初始奖品池数量不合法', 2);
        return false;
      }
      if (!rateRe.test(row.expected_gold_rate)) {
        $this.alert('奖品池期望中奖率不合法', 2);
        return false;
      }
      if (!rateRe.test(row.initial_success_rate)) {
        $this.alert('全局初始成功率不合法', 2);
        return false;
      }
      var params = {};
      params.base_prize_amount = row.base_prize_amount;
      params.expected_gold_rate = row.expected_gold_rate;
      params.initial_success_rate = row.initial_success_rate;
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/save/wawaji/global/info'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $('.js-edit-global-modal').modal('hide');
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageRoomTrigger.vue